<template>
  <footer class="footer">
    <a href="https://prismic.io" target="_blank" rel="noopener">
      <img class="logo" src="../assets/img/prismic-logo.svg" alt="Prismic">
    </a>
  </footer>
</template>

<script>
export default {
  name: 'FooterPrismic'
}
</script>

<style scoped>
.footer {
  padding: 40px 0;
  text-align: center;
}

.logo {
  width: 140px;
}
</style>
